import React from "react";
import { useSelector } from "react-redux";

import DocumentModal from "components/Widgets/BambooHRTabs/Documents/DocumentModal/DocumentModal";

import CustomButton from "components/common/Button";
import DocumentModule from "components/Widgets/BambooHRTabs/Documents/DocumentModal/DocumentModule.enum";

import getRequest from "util/APIHelperGet";
import { baseUrl } from "util/APIBaseUrl";

import {
  PictureAsPdfOutlined as PictureAsPdfOutlinedIcon,
  ImageOutlined as ImageOutlinedIcon,
  AddOutlined as AddOutlinedIcon,
  Cancel as CancelIcon,
} from "@mui/icons-material";

import "./AttachDocuments.scss";
import { Chip } from "@mui/material";

function AttachDocuments({
  onAttached,
  employeeId = null,
  showAddDocumentModal,
  setShowAddDocumentModal,
  leaveDocuments = [],
  onDelete,
}) {
  const platformConfig = useSelector((state) => state.PlatformConfig.platformConfig);
  const { TIMEOFF_DOCUMENT_SIZE = 2 * 1024 * 1024 } = platformConfig?.payload || {};

  const getUploadLeaveDocumentSignedUrl = async (fileName, fileType, fileSize) => {
    const userId = employeeId || JSON.parse(localStorage.getItem("loggedInUser"))?.userId;
    const { payload } = await getRequest(
      `${baseUrl}/employee/${userId}/leave_request/document/upload-url?fileName=${encodeURIComponent(fileName)}&fileType=${encodeURIComponent(fileType)}&fileSize=${fileSize}`
    );
    if (payload?.error) {
      throw new Error(payload?.error[0]?.description);
    }
    return payload;
  };

  const handleSave = async (files) => {
    onAttached(
      files
        .map((fileData) => {
          const { uniqueFileName = "", file = {}, status } = fileData || {};
          const { type: fileType, size } = file || {};

          if (status === "complete")
            return {
              fileName: uniqueFileName,
              documentName: fileData.fileName,
              fileType,
              size,
            };
          return null;
        })
        .filter(Boolean)
    );
  };

  return (
    <div>
      <DocumentModal
        type="add"
        open={showAddDocumentModal}
        module={DocumentModule.LEAVE_DOCUMENTS}
        onGettingSignedUrl={getUploadLeaveDocumentSignedUrl}
        isLoading={false}
        fetchEmployeeDocumentList={[]}
        onSaveClicked={handleSave}
        onClose={() => {
          setShowAddDocumentModal(false);
        }}
        maxFileSizeLimit={TIMEOFF_DOCUMENT_SIZE}
        maxFileSizeLimitText={`(max. ${TIMEOFF_DOCUMENT_SIZE / 1024 / 1024}MB)`}
        maxFileUploadCount={0}
      />
      <p className="heading-h5-semibold attach-documents-heading">Attach documents</p>
      <p className="para-body-s-regular attach-documents-description"> You can attach as many documents as needed</p>

      <div className="mb-075 mt-075 document-chip-wrapper">
        {leaveDocuments?.length > 0 &&
          leaveDocuments?.map((file) => (
            <Chip
              icon={
                file.fileType === "application/pdf" ? (
                  <PictureAsPdfOutlinedIcon className="document-chip-icon" />
                ) : (
                  <ImageOutlinedIcon className="document-chip-icon" />
                )
              }
              size="medium"
              label={file?.documentName}
              className="para-body-s-medium-important color-text-body-secondary-important document-chip"
              onDelete={() => onDelete(file)}
              deleteIcon={<CancelIcon className="document-chip-delete-icon" />}
              key={file?.fileName}
            />
          ))}
        {leaveDocuments?.length === 0 && (
          <CustomButton
            variant="outlined"
            color="primary"
            size="medium"
            onClick={() => setShowAddDocumentModal(true)}
            label="Add documents"
            startIcon={<AddOutlinedIcon className="document-plus-icon-btn" />}
          />
        )}
        {leaveDocuments?.length > 0 && (
          <Chip
            size="medium"
            color="primary"
            variant="outlined"
            onClick={() => setShowAddDocumentModal(true)}
            label="Add more"
            icon={<AddOutlinedIcon className="document-plus-icon-chip" />}
            className="add-more-chip"
          />
        )}
      </div>
    </div>
  );
}

export default AttachDocuments;
